import { render, staticRenderFns } from "./SummerFestivalBuildingCard.vue?vue&type=template&id=2354c590"
import script from "./SummerFestivalBuildingCard.vue?vue&type=script&lang=js"
export * from "./SummerFestivalBuildingCard.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports